import {
  SnackbarKey,
  SnackbarProvider,
  SnackbarProviderProps
}                                      from 'notistack';
import { useRef }                      from 'react';
import { IconButton }                  from '@mui/material';
import { Close }                       from '@mui/icons-material';
import { colorTheme }                  from '@styles/muiTheme';
import { InfoIcon, StyledMaterialDesignContent } from '@styles/Shared/StyledNotistack';

const MAX_SNACK = 3;

export const NotistackProvider = (props: SnackbarProviderProps) => {
  const notistackRef = useRef<SnackbarProvider>(null);
  const portal = document.querySelector('body') as HTMLElement;

  const onClickDismiss = (key: SnackbarKey) => () => {
    notistackRef.current?.closeSnackbar(key);
  };

  return (
    <SnackbarProvider
      ref         = {notistackRef}
      maxSnack    = {MAX_SNACK}
      domRoot     = {portal}
      iconVariant = {{ info: <InfoIcon /> }}
      Components={{
        success: StyledMaterialDesignContent,
        error: StyledMaterialDesignContent,
        info: StyledMaterialDesignContent,
        warning: StyledMaterialDesignContent,
      }}
      action      = {(key: SnackbarKey) => (
        <IconButton size="small" onClick={onClickDismiss(key)}>
          <Close htmlColor={colorTheme.palette.common.white} />
        </IconButton>
      )}
      {...props}
    />
  );
};
